export default __webpack_public_path__ + "static/media/logo.632e7442.png";